import { TFunction } from 'i18next'
import { OnboardingStep } from 'types/onboardingTypes'

export function getOnePlan(t: TFunction): OnboardingStep {
  return {
    id: 'the_one_plan',
    type: 'information',
    allowNext: true,
    wordings: {
      title: t('the-one-plan.title'),
      subtitle: t('the-one-plan.subtitle')
    }
  }
}
